import React from "react";
import BurgerMenu from "../../img/svg/burger_menu.svg";
import { setSidebarOpened } from "../../store/mainSlice";
import { useDispatch } from "react-redux";

const HeaderIconBurger = () => {
  const dispatch = useDispatch();
  return (
    <div className="burger_menu mt-5" onClick={() => dispatch(setSidebarOpened(true))}>
      <img src={BurgerMenu} alt="burger menu" style={{ width: "23px" }} />
    </div>
  );
};

export default HeaderIconBurger;
